<template>
  <div class="card-form container" v-if="dataFetched">
    <b-row class="mb-5 w-100 d-flex justify-content-around" :style="cardStyle">
      <img alt="Logo" :src="emissor.logo" class="max-h-80px" />
      <div class="mt-5" style="float: right; text-align: right">
        <span>{{ emissor.nome }} - {{ emissor.telefone }}</span> <br />
        <span v-if="emissor.cnpj_cpf.length < 14"
          >CPF: {{ formatCpfCnpj(emissor.cnpj_cpf) }}</span
        >
        <span v-if="emissor.cnpj_cpf.length >= 14"
          >CNPJ: {{ formatCpfCnpj(emissor.cnpj_cpf) }}</span
        >
        <br />
        <span>{{
          `${emissor.logradouro} - ${emissor.numero} - ${emissor.bairro}, ${emissor.cep}`
        }}</span
        ><br />
        <span>{{ `${emissor.cidade} - ${emissor.uf}` }}</span>
        <br />
      </div>
    </b-row>

    <strong>Ordem de Compra: </strong><span> {{ numero }} </span>
    <div>
      <div>
        <b-card
          title="Fornecedor"
          tag="article"
          class="my-2 border border-primary"
          :style="cardStyle"
        >
          <b-card-text>
            <strong>Nome: </strong>{{ fornecedor.nome }}<br />
            <strong
              v-if="
                fornecedor.cnpj_cpf !== null && fornecedor.cnpj_cpf.length < 14
              "
              >CPF: {{ formatCpfCnpj(fornecedor.cnpj_cpf) }} <br />
            </strong>
            <strong
              v-if="
                fornecedor.cnpj_cpf !== null && fornecedor.cnpj_cpf.length >= 14
              "
              >CNPJ: {{ formatCpfCnpj(fornecedor.cnpj_cpf) }}<br
            /></strong>

            <strong v-if="fornecedor.telefone">Telefone:</strong
            >{{ fornecedor.telefone }}<br />
            <div style="white-space: normal" v-if="fornecedor.cep">
              <strong>Endereço: </strong>
              {{ fornecedor.logradouro }}, {{ fornecedor.numero }},{{
                fornecedor.bairro
              }},{{ fornecedor.complemento }} {{ fornecedor.cep }},{{
                fornecedor.cidade
              }}-{{ fornecedor.uf }}
            </div>
          </b-card-text>
        </b-card>

        <b-card
          title="Produtos"
          tag="article"
          class="mb-2 border border-primary"
        >
          <b-card-text>
            <b-table
              v-if="produtos.length > 0"
              striped
              small
              hover
              :items="tableItems"
            >
              <template #row-details="row">
                <b-row
                  v-if="getProdutoObservacao(row)"
                  style="white-space: pre-line"
                >
                  <b-col>Observacao: {{ getProdutoObservacao(row) }} </b-col>
                </b-row>
              </template>
            </b-table>
          </b-card-text>
        </b-card>
        <b-card
          title="Pagamentos"
          tag="article"
          class="mb-2 border border-primary"
          :style="cardStyle"
        >
          <b-card-text
            v-for="(pagamento, index) in pagamentos"
            :key="pagamento.descricao"
          >
            <label>{{ pagamento.paymentMode.name }}</label>
            <b-table
              v-if="produtos.length > 0"
              striped
              small
              fixed
              hover
              :items="tablePagamentoItems(index)"
            />
          </b-card-text>
        </b-card>

        <b-card
          title="Outras informaçoes"
          tag="article"
          class="my-2 border border-primary"
          :style="cardStyle"
        >
          <b-card-text>
            <strong>Observação: </strong> {{ observacao }} <br />
            <strong>Data Solicitação: </strong>
            {{ data_solicitacao | moment("DD/MM/YYYY") }}
            <br />
            <strong>Total da Ordem R$: </strong>
            {{ numberToReal(valorTotal, 2) }}
          </b-card-text>
        </b-card>
      </div>
    </div>
    <div class="mt-5 w-100 d-flex justify-content-end">
      <img
        alt="Logo"
        :src="layoutConfig('self.logo.secundary')"
        class="max-h-60px mr-5"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { mask } from "vue-the-mask";
import moment from "moment";

export default {
  name: "app-link-ordem-compra",
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin],
  directives: {
    mask,
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  data() {
    return {
      uuid: null,
      allStatus: [],
      dataFetched: false,
      fornecedor: null,
      emissor: null,
      data_solicitacao: null,
      observacao: null,
      pagamentos: [],
      produtos: null,
      status: null,
      valorTotal: null,
      numero: null,
      finished: false,
      contatoResposta: null,
      windowWidth: window.innerWidth,
      dataResposta: null,
      solicitante: null,
    };
  },
  watch: {},
  computed: {
    ...mapGetters(["pageTitle", "layoutConfig"]),
    tableItems() {
      return this.produtos.map((produto) => ({
        codigo: produto.product?.codigo,
        nome: produto.product.descricao,
        quantidade: produto.quantity,
        preco: this.numberToReal(produto.price, 2),
        total: this.numberToReal(produto.totalPrice, 2),
        _showDetails: true,
      }));
    },
    produtoObservacoes() {
      return this.produtos.map((produto) => produto?.product?.obs);
    },
    isMobile() {
      return this.windowWidth < 569;
    },
    cardStyle() {
      return {
        width: this.isMobile ? "94vw" : "",
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    getProdutoObservacao(row) {
      const observacaoIndex = this.tableItems.findIndex(
        (el) => el.codigo === row.item.codigo
      );
      if (observacaoIndex === -1) return null;
      return this.produtoObservacoes[observacaoIndex];
    },
    tablePagamentoItems(index) {
      return this.pagamentos[index].range.map((parcela, index) => ({
        parcela: index + 1,
        "Valor R$": this.numberToReal(parcela.value, 2),
        vencimento: moment(parcela.date).format("DD/MM/YYYY"),
      }));
    },
  },
  async mounted() {
    const { uuid } = this.$route.params;
    this.setLoading(true);
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
    this.$http
      .post("/ordemcompra/busca-ordem-compra", {
        uuid,
      })
      .then(({ data }) => {
        this.fornecedor = data.fornecedor;
        this.emissor = data.emissor;
        this.data_solicitacao = data.data_solicitacao;
        this.observacao = data.observacao;
        this.pagamentos = data.pagamentos;
        this.produtos = data.produtos;
        this.status = data.status;
        this.valorTotal = data.valorTotal;
        this.numero = data.numero;
        this.dataFetched = true;
        this.setLoading(false);
      })
      .catch((error) => {
        this.setLoading(false);
        this.$toast.error(`Erro ao buscar ordem:\n${error}`);
      });
    await this.getInit();
  },
  created() {},
};
</script>
<style scoped>
svg {
  outline-width: 0;
  outline-color: transparent;
  color: rgb(241, 249, 255);
}

.container {
  background-color: white;
  border-radius: 10px;
  padding: 1rem;
  box-shadow: 0px 0px 30px 0px rgba(82, 63, 105, 0.05);
}

.select-city .vs__search::placeholder,
.select-city .vs__dropdown-toggle,
.select-city .vs__dropdown-menu {
  height: 10rem !important;
  /* width:  100%; */
  background-color: green !important;
}

.contato-input {
  height: 3rem;
}
</style>